<div [formGroup]="form" class="p-d-flex p-flex-row p-fluid">
  <!-- Godina nastanka -->
  <div class="flex-1-1 p-mr-4">
    <kodit-field fieldLabel="Godina nastanka">
      <kodit-number-input
        [ctrlMaxLength]="4"
        [ctrlMinValue]="1900"
        [ctrlOnlyIntegers]="true"
        [ctrlUseGrouping]="false"
        [formCtrl]="form.controls.godinaNastanka"
        formCtrlId="godinaUnosa"
      ></kodit-number-input>
    </kodit-field>
  </div>
  <!-- Sadrzaj -->
  <div class="flex-1-1 p-mr-4">
    <kodit-field fieldLabel="Sadržaj">
      <kodit-klasifikaciona-oznaka-autocomplete
        (optionChanged)="handleSadrzajChanged($event)"
        [isForArhivskaForm]="false"
        [kategorijaModel]="sadrzajModel"
        [shouldAppendToBody]="true"
      ></kodit-klasifikaciona-oznaka-autocomplete>
    </kodit-field>
  </div>
  <!-- Datum upisa od -->
  <div class="flex-1-1 p-mr-4">
    <kodit-field fieldLabel="Datum upisa od" fieldLabelFor="datumUpisaOd">
      <kodit-calendar
        [formCtrl]="form.controls.datumUpisaOd!"
        formCtrlId="datumUpisaOd"
      ></kodit-calendar>
    </kodit-field>
  </div>
  <!-- Datum upisa do -->
  <div class="flex-1-1 p-mr-4">
    <kodit-field fieldLabel="Datum upisa do" fieldLabelFor="datumUpisaDo">
      <kodit-calendar
        [formCtrl]="form.controls.datumUpisaDo!"
        formCtrlId="datumUpisaDo"
      ></kodit-calendar>
    </kodit-field>
  </div>
</div>
